"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const immer_1 = __importDefault(require("immer"));
/**
 * reducerWithImmer({})
 *  .case(actions.hoge, draft => {
 *    draft.fuga ++;
 *  })
 */
function reducerWithImmer(initialState) {
    const cases = {};
    const resets = [];
    const builder = {
        case(actionCreator, handler) {
            if (process.env.NODE_ENV !== 'production') {
                if (typeof actionCreator.type !== 'string') {
                    throw new Error(`ActionCreator must has string member "type"`);
                }
                if (actionCreator.type in cases) {
                    throw new Error(`${actionCreator.type} is already set in reducer!`);
                }
                if (typeof handler !== 'function') {
                    throw new Error(`Invalid handler set with "${actionCreator.type}"`);
                }
            }
            cases[actionCreator.type] = handler;
            return builder;
        },
        reset(actionCreator) {
            resets.push(actionCreator.type);
            return builder;
        },
        toReducer() {
            return (state, action) => {
                if (resets.includes(action.type)) {
                    return initialState;
                }
                const handler = cases[action.type];
                return handler
                    ? immer_1.default(state || initialState, draft => handler(draft, action.payload))
                    : state || initialState;
            };
        }
    };
    return builder;
}
exports.reducerWithImmer = reducerWithImmer;
